export default __webpack_public_path__ + "static/media/parcours_3_lettre_ofice_etrangers-min.095d2aa0.jpg";